module.exports = __webpack_public_path__ + "static/unnamed-6f0bd21c2e593a85f1398386b5a30975.jpg";